import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isstripoEmailBuilderModal: "",
  isstripoEmailBuilderHTML: "",
  isStripoFormLink: "",
  isStripoHtmlAndCssGet: "",
  isStripoBookingLink: "",
};

const StripoEmailSlice = createSlice({
  name: "stripoemail",
  initialState,
  reducers: {
    reset: () => initialState,
    StripoEmailBuilderModal: (state, action) => {
      state.isstripoEmailBuilderModal = action.payload;
    },
    StripoEmailBuilderSave: (state, action) => {
      state.isstripoEmailBuilderHTML = action.payload;
    },
    StripoBookingLink: (state, action) => {
      state.isStripoBookingLink = action.payload;
    },
    StripoFormLink: (state, action) => {
      state.isStripoFormLink = action.payload;
    },
    StripoHtmlAndCssGet: (state, action) => {
      state.isStripoHtmlAndCssGet = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { reset, StripoEmailBuilderModal, StripoEmailBuilderSave, StripoBookingLink, StripoFormLink, StripoHtmlAndCssGet } = StripoEmailSlice.actions;
export default StripoEmailSlice.reducer;
